import { FormattedMessage, useIntl } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useSearchState } from '@xing-com/crate-jobs-hooks';

import { Tag } from '../applied-filters.styles';

export const SinceTag: React.FC = () => {
  const { formatMessage } = useIntl();
  const { since } = useSearchState();
  const { deleteSearchParameter } = useSearchParameter();

  if (!since) {
    return null;
  }

  const onClick = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.since, { replace: false });
  };

  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: formatMessage({
        id: 'JOBS_SEARCH_FILTER_SINCE_VALUE',
      }),
    }
  );

  return (
    <Tag onClick={onClick} aria-label={ariaLabel}>
      <FormattedMessage id="JOBS_SEARCH_FILTER_SINCE_VALUE" />
    </Tag>
  );
};
